import {
  GenericModalHeadlineLevelTwo,
  StyledInputSelect,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function ClinicAssociationSelector({
  basicEventObject,
  setBasicEventObject,
  mentorClinicAssociationData,
  changeLocationBasedOnMentorOrClinicLocation,
  isDisabled,
}) {
  if (!Array.isArray(mentorClinicAssociationData) || mentorClinicAssociationData?.length === 0) {
    return null
  }

  return (
    <div>
      <GenericModalHeadlineLevelTwo>Associated Clinic</GenericModalHeadlineLevelTwo>
      <StyledInputSelect
        value={basicEventObject?.contextId || ''}
        onChange={(e) => {
          setBasicEventObject((prev) => ({ ...prev, contextId: e.target.value }))
          if (e.target.value !== '') {
            changeLocationBasedOnMentorOrClinicLocation(undefined, e.target.value)
          } else {
            changeLocationBasedOnMentorOrClinicLocation(undefined)
          }
        }}
        disabled={isDisabled}
      >
        <option value="">None</option>
        {mentorClinicAssociationData?.map((item, index) => {
          return (
            <option key={item?.id} value={item?.id}>
              {item?.name}
            </option>
          )
        })}
      </StyledInputSelect>
    </div>
  )
}
